import _ from "lodash";
import { push } from "connected-react-router";

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, showSuccessMessage } from "./ui";
import { getQuestionInfo, createQuestion, editQuestion } from "../../request";

//Редактирование формы вопроса
export const SET_QUESTION_HEADER = "Set question header";
export const SET_QUESTION_ANSWER_TEXT = "Set question answer text";
export const SET_QUESTION_ROLE = "Set question role";
export const TOGGLE_QUESTION_CONSULTANTS_ROLE = "Toggle question consultants role";

//Подвопросы
export const SET_SUBQ_HEADER = "Set subquestion header";
export const SET_SUBQ_ANSWER_TEXT = "Set subquestion answer text";
export const ADD_NEW_SUBQUESTION = "Add new subquestion";
export const DELETE_SUBQUESTION = "Delete subquestion";

//Очистка формы вопроса
export const CLEAR_QUESTION_FORM = "Clear question form";

//Создание вопроса
export const QUESTION_CREATION_START = "Question creation start";
export const QUESTION_CREATED_SUCCESSFULLY = "Question created successfully";
export const QUESTION_CREATION_FAILED = "Failure during question creation";

//Загрузка информации о редактируемом вопросе
export const EDITING_QUESTION_LOADING_START = "Editing question form loading start";
export const EDITING_QUESTION_LOADED_SUCCESSFULLY = "Editing question form loaded successfully";
export const EDITING_QUESTION_LOADING_FAILED = "Failure during editing question form load";

//Редактирование вопроса
export const QUESTION_EDITING_START = "Question editing start";
export const QUESTION_EDITED_SUCCESSFULLY = "Question edited successfully";
export const QUESTION_EDITING_FAILED = "Failure during question editig";

//РЕДАКТИРОВАНИЕ ФОРМЫ ВОПРОСА

//Название вопроса
export const setQuestionHeader = value => ({
  type: SET_QUESTION_HEADER,
  payload: { value }
});

//Текст вопроса
export const setQuestionAnswerText = value => ({
  type: SET_QUESTION_ANSWER_TEXT,
  payload: { value }
});

//Роль вопроса
export const setQuestionRole = value => ({
  type: SET_QUESTION_ROLE,
  payload: { value }
});

//Подвопросы
//Текст подвопроса
export const setSubQuestionHeader = (value, subQIndex) => ({
  type: SET_SUBQ_HEADER,
  payload: { value, subQIndex }
});

//Ответ на подвопрос
export const setSubQuestionAnswerText = (value, subQIndex) => ({
  type: SET_SUBQ_ANSWER_TEXT,
  payload: { value, subQIndex }
});

//Добавить новый подвопрос
export const addNewSubQuestion = () => ({ 
  type: ADD_NEW_SUBQUESTION,
});

//Удаление подвопроса
export const deleteSubQuestion = subQIndex => ({
  type: DELETE_SUBQUESTION,
  payload: { subQIndex }
});

//Очистка формы вопроса
export const clearQuestionForm = () => ({
  type: CLEAR_QUESTION_FORM
});

//СОЗДАНИЕ ВОПРОСА
const startCreation = () => ({
  type: QUESTION_CREATION_START
});

const creationSuccess = () => ({
  type: QUESTION_CREATED_SUCCESSFULLY,
});

const creationFailure = () => ({
  type: QUESTION_CREATION_FAILED,
});

export const createQuestionAsync = () => {
  return async (dispatch, getState) => {
    dispatch(startCreation());
    await dispatch(checkAndRenewTokens());
    const currentState = getState();
    const question = currentState.editQuestion.question;

    //Cформируем данные для родительского вопроса
    question.parentId = null; //Для корневого вопроса parentId = null
  
    //Обработка массива children (обязателен для родительского вопроса)
    question.children = question.children.map(child => {
      const newChild =  _.omit(child, ['role', 'parentId', 'is_visible', 'isAdded']);
      return newChild;
    });
    const data = _.omit(question, ['id']);

    try {
      const accessToken = localStorage.getItem("accessToken");
      await createQuestion(accessToken, data);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(push('questions'));
      dispatch(showErrorMessage('Ошибка при создании вопроса'));
      return dispatch(creationFailure());
    }
    dispatch(push('questions'));
    dispatch(showSuccessMessage('Новый вопрос создан'));
    return dispatch(creationSuccess());

  };
};

//ЗАГРУЗКА ИНФОРМАЦИИ О РЕДАКТИРУЕМОМ ВОПРОСЕ
const startLoading = () => ({
  type: EDITING_QUESTION_LOADING_START
});

const loadSuccess = question => ({
  type: EDITING_QUESTION_LOADED_SUCCESSFULLY,
  payload: { question },
}); 

const loadFailure = () => ({ 
  type: EDITING_QUESTION_LOADING_FAILED,
});

//ЗАГРУЗКА ИНФОРМАЦИИ О ВОПРОСЕ
export const getEditingQuestionAsync = questionId => {
  return async (dispatch) => {
    dispatch(startLoading());
    await dispatch(checkAndRenewTokens());
    let question; 

    try {
      const accessToken = localStorage.getItem("accessToken"); 
      question = await getQuestionInfo(accessToken, questionId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при загрузке информации о вопросе'));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(question));
  };
};

//РЕДАКТИРОВАНИЕ ВОПРОСА
const startEditing = () => ({
  type: QUESTION_EDITING_START
});

const editingSuccess = () => ({
  type: QUESTION_EDITED_SUCCESSFULLY,
});

const editingFailure = () => ({
  type: QUESTION_EDITING_FAILED,
});

export const editQuestionAsync = questionId => { 
  return async (dispatch, getState) => {
    dispatch(startEditing());
    await dispatch(checkAndRenewTokens());
    const currentState = getState();
    const question = currentState.editQuestion.question;

    //Обработка массива children (обязателен для родительского вопроса)
    question.children = question.children.map(child => {
      const newChild =  _.omit(child, ['role', 'parentId', 'is_visible', 'isAdded']);
      return newChild;
    });
    const data = _.omit(question, ['id']);

    try {
      const accessToken = localStorage.getItem("accessToken");
      await editQuestion(accessToken, data, questionId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при редактировании вопроса'));
      return dispatch(editingFailure());
    }
    dispatch(push('/question/' + questionId));
    dispatch(showSuccessMessage('Вопрос отредактирован'));
    return dispatch(editingSuccess());
  };
};
